// Important: polyfills must come before the other imports!
import "@formatjs/intl-numberformat/polyfill";
import "@formatjs/intl-numberformat/locale-data/en";
import "@formatjs/intl-numberformat/locale-data/de";
import "@bn/fonts";

import "./errorReporting";
import React from "react";
import { createRoot } from "react-dom/client";
import "@translations/i18n";
import { de } from "date-fns/locale";
import { setDefaultOptions } from "date-fns";
import { initAxios } from "@bn/api";
import { App } from "./App.tsx";
import { initGTM } from "./gtm";
import "@components/Chart/highcharts/highchartsInit";

setDefaultOptions({ locale: de });

if (import.meta.env.VITE_APP_ENVIRONMENT === "mock") {
  const { worker } = require("./mocks/browser");
  worker.start();
}

initAxios({
  baseURL: import.meta.env.VITE_APP_API_BASE_URL!,
});

initGTM();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
